import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, DollarSign } from 'lucide-react';
import { StatusBadge } from '../StatusBadge';

export function ClientMoneySection({ clientId, client, transactions, onMarkPaid }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-serif font-bold text-foreground flex items-center gap-2">
          <DollarSign className="w-5 h-5" />
          Money
        </h2>
        <button
          onClick={() => navigate(`/transactions/new?client=${clientId}`)}
          className="text-primary hover:text-primary/80 text-sm flex items-center gap-1"
          data-testid="add-transaction-button"
        >
          <Plus className="w-4 h-4" />
          New
        </button>
      </div>
      {client.total_spent > 0 && (
        <div className="bg-surface-raised border border-border rounded-lg p-3 mb-2">
          <p className="text-sm text-text-secondary">Lifetime Total</p>
          <p className="text-2xl font-bold text-success">${client.total_spent.toFixed(2)}</p>
        </div>
      )}
      {transactions.length === 0 ? (
        <div className="bg-surface border border-border rounded-lg p-4 text-center text-text-muted text-sm">
          No transactions yet
        </div>
      ) : (
        <div className="space-y-2">
          {transactions.map((txn) => (
            <div
              key={txn.id}
              className="bg-surface border border-border rounded-lg p-3"
              data-testid={`transaction-${txn.id}`}
            >
              <div className="flex items-start justify-between mb-1">
                <h3 className="font-medium text-foreground">{txn.description}</h3>
                <div className="flex items-center gap-2">
                  {txn.type === 'invoice' && txn.invoice_status === 'unpaid' && (
                    <button
                      onClick={() => onMarkPaid(txn.id)}
                      className="text-xs bg-success/10 text-success px-2 py-1 rounded border border-success/20 hover:bg-success/20 transition-colors"
                      data-testid={`mark-paid-${txn.id}`}
                    >
                      Mark Paid
                    </button>
                  )}
                  {txn.invoice_status && <StatusBadge status={txn.invoice_status} />}
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-text-secondary capitalize">{txn.type}</span>
                <span className={`font-medium ${txn.type === 'expense' ? 'text-alert' : 'text-success'}`}>
                  {txn.type === 'expense' ? '-' : '+'}${txn.amount.toFixed(2)}
                </span>
              </div>
              {txn.due_date && txn.type === 'invoice' && (
                <p className="text-xs text-text-muted mt-1">Due: {txn.due_date}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
